/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { AuthoringRegion } from 'src/core/types/regionTypes';
import {
    AppsToEmailSwagger,
    AppsToExportSwagger,
    UserMigrationInfoSwagger
} from 'src/verticals/azureMigrationModal/services/azureMigrationSwagger';
import { AppToEmailStore } from 'src/verticals/azureMigrationModal/stores/AppToEmailStore';
import { AppToExportStore } from 'src/verticals/azureMigrationModal/stores/AppToExportStore';
import { UserMigrationInfoStore } from 'src/verticals/azureMigrationModal/stores/UserMigrationInfoStore';

export const appsToEmailSwaggerToAppToEmailStores = (swagger: AppsToEmailSwagger, region?: AuthoringRegion) =>
    new AppToEmailStore(swagger.id, {
        appId: swagger.id,
        appName: swagger.name,
        collaborators: swagger.collaborators,
        hasPredictionResource: swagger.hasPredictionResource,
        region
    });

export const appsToExportSwaggerToAppToExportStores = (swagger: AppsToExportSwagger, region?: AuthoringRegion) =>
    new AppToExportStore(swagger.appId, {
        appId: swagger.appId,
        appName: swagger.appName,
        ownerEmail: swagger.ownerEmail,
        hasPredictionResource: swagger.hasPredictionResource,
        region
    });

export const userMigrationInfoSwaggerToUserMigrationInfoStores = (swagger: UserMigrationInfoSwagger) =>
    new UserMigrationInfoStore(swagger.region, {
        region: swagger.region,
        endpoint: swagger.endpoint,
        serviceKey: swagger.subscriptionKey
    });
